import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/hooks/useAppSelector';

import { setSearchHistory } from '../services/actions';
import { selectSearchHistory } from '../services/selectors';
import type { SearchHistory } from '../types';

export const useSearchHistory = () => {
    const dispatch = useDispatch();
    const searchHistory = useAppSelector(selectSearchHistory);

    const updateHistory = (option: SearchHistory) => {
        dispatch(setSearchHistory(option));
    };

    return {
        searchHistory,
        updateHistory,
    };
};
